var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.HeaderDashboardCards,{attrs:{"data-testid":"departments-header-dashboard","aria-label":"Departments summary","metrics":_setup.cards,"variant":"count-only","action-label":_vm.actionLabel},on:{"select":_setup.handleSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }